module.exports = __webpack_public_path__ + "img/talud.0746b86a.png";